import { useRef, useEffect } from 'react';
import { useAppDispatch } from 'stores/hooks';
import { signInProviderAsync } from 'stores/auth/authSlice';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

export default function GoogleSSO() {
  const dispatch = useAppDispatch();
  const googleSSO = useRef(null);

  useEffect(() => {
    if (googleSSO.current) {
      try {
        window?.google?.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: (res) => {
            if (res) {
              dispatch(signInProviderAsync({
                provider: 'google',
                clientId: GOOGLE_CLIENT_ID,
                accessToken: res.credential,
              }));
            }
          },
        });
        window?.google?.accounts.id.renderButton(googleSSO.current, {
          theme: 'outline',
          size: 'large',
          type: 'standard',
          text: 'signin_with',
          shape: 'rectangular',
          logo_alignment: 'left',
          width: '220',
        });
      } catch (error) {
        console.error(error);
      }
    }
  }, [dispatch]);

  return (
    <div
      className='w-[220px] mx-auto h-[60px]'
      ref={googleSSO}
    />
  );
}

